module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid15_980x841.60f073b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid15_980x841.jpg
// module id = r8eM
// module chunks = 0